import sbjs from 'sourcebuster';
// import { Analytics } from '@hellopret/hellostats';

sbjs.init({
  timezone_offset: 1,
});

//analyse query string to extract 'utm_adgroup_id' paramaters
const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);
const utm_adgroup_id = urlParams.get('utm_adgroup_id')
//console.log('utm_source: '+sbjs.get.first.src)
//store it wihtin sourcebuster (inside 'first')
sbjs.get.first.adgroup= utm_adgroup_id;

// manage gclid

//read it from the url param
let utm_gcl_id = urlParams.get('gclid');

if(utm_gcl_id){
  console.log('gclid in params');
}else{
  //read it from the cookie (cf hellopret_sitesourcebuster.js)
  utm_gcl_id =getCookie('sbjs_gclid');
}
console.log('utm_gcl_id: '+utm_gcl_id);
sbjs.get.first.gclid= utm_gcl_id;
//console.log(sbjs.get.first);
window.sbjsData= JSON.stringify(sbjs.get)

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
}
// const analytics = new Analytics({
//   transportUrl: 'https://www.hellopret.fr/stats/pageview/',
//   propertyId: 'UA-71421248-7'
// })

// analytics.trackPageView();

// export {
//   analytics
// };
